import axios, { AxiosError } from 'axios';
import * as React from 'react';
import { RequestInitalizeGoogleCalendar } from '../asyncHelpers/settingsService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

export default function useAsyncInitalizeCalendar() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncInitalizeGoogleCalendar = async (): Promise<boolean | undefined> => {
        try {
            setRequestStatus(RequestStatus.active);

            await RequestInitalizeGoogleCalendar(request_token.token);

            setRequestStatus(RequestStatus.success);

            return true;
        } catch (e: any) {
            if (!axios.isCancel(e)) {
                if (axios.isAxiosError(e)) {
                    const error = e as AxiosError;
                    if (e.response?.status == 400) {
                        /* Notify user of failed http request */
                        const toastData = createErrorToast(e.response.data);

                        dispatch(createToast({ toastData }));
                    }
                }
                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncInitalizeGoogleCalendar,
    };
}
